import "~/css/app.css";
import {Router} from "@solidjs/router";
import {FileRoutes} from "@solidjs/start/router";
import AppRoot from "~/root";

export default function App() {

    return (<>
            <Router root={AppRoot}>
                <FileRoutes/>
            </Router>
        </>
    )
}